import { DatePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ENVIRONMENT } from '@cfp/core';
import { EnergyLabel } from '@cfp/shared/energy-label';
import { Alert } from '@cfp/ui';
import { TranslatedRouterLink } from '@cfp/ui/common';
import { TranslateModule } from '@ngx-translate/core';
import { ObjectTypeDTO } from 'csr-asset-app';
import { LabelImprovement } from '../label-improvement';

@Component({
  selector: 'cfp-label-improvement-inline',
  templateUrl: './label-improvement-inline.html',
  styleUrls: ['./label-improvement-inline.scss'],
  imports: [DatePipe, TranslateModule, EnergyLabel, TranslatedRouterLink, Alert]
})
export class LabelImprovementInline extends LabelImprovement {
  protected readonly ObjectTypeDTO = ObjectTypeDTO;

  protected readonly environment = inject(ENVIRONMENT);

  constructor() {
    super();
    // The inline label improvement only shows the main label
    this.showMainLabelOnly = true;
  }
}
